import { ModuleConfig } from '@/core/module';
import { employerRoutes } from './routes';

export const EmployersModule: ModuleConfig = {
    name: 'employers',
    routes: employerRoutes,
    initialize: () => {
        console.log('Employers module initialized');
    }
};
